import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UrlBuilderService } from 'projects/communication/src/app/services/url-builder.service';

@Injectable({
  providedIn: 'root',
})
export class ApiCallService {
  private baseUrl: string;

  constructor(private http: HttpClient, private urlBuilder: UrlBuilderService) {
    this.baseUrl = this.urlBuilder.apiUrl;
  }

  /**
   * Function to make a get call
   *
   * @param path Api Path
   * @param params Params
   */
  public get(path: string, params?: any, isBlob?: boolean): Promise<any> {
    const url = `${this.urlBuilder.apiUrl}/${path}`;
    return this.http.get(url, isBlob ? { params, responseType: 'blob' } : params).toPromise();
  }

  /**
   * Function to make a get call
   *
   * @param path Api Path
   * @param params Params
   */
  public post(path: string, params?: any): Promise<any> {
    const url = `${this.urlBuilder.apiUrl}/${path}`;
    return this.http.post(url, params || {}).toPromise();
  }
}
